import request from '@/config/axios'

export interface ProductServiceGuaranteeVO {
  id?: number
  name: string
  iconUrl?: string
  sort: number
  status: number
  createTime?: string
}

export const getServiceGuaranteePage = async (params: any) => {
  return await request.get({ url: '/product/service-guarantee/page', params })
}

export const getServiceGuarantee = async (id: number) => {
  return await request.get({ url: '/product/service-guarantee/get?id=' + id })
}

export const createServiceGuarantee = async (data: ProductServiceGuaranteeVO) => {
  return await request.post({ url: '/product/service-guarantee/create', data })
}

export const updateServiceGuarantee = async (data: ProductServiceGuaranteeVO) => {
  return await request.put({ url: '/product/service-guarantee/update', data })
}

export const deleteServiceGuarantee = async (id: number) => {
  return await request.delete({ url: '/product/service-guarantee/delete?id=' + id })
}

/** 开启中的精简列表（商品编辑勾选） */
export const getSimpleServiceGuaranteeList = async () => {
  return await request.get({ url: '/product/service-guarantee/list-all-simple' })
}
